import { flow, types } from "mobx-state-tree";
import { Species } from "~/mobx/entities/species/Species";
import { getEnv } from "~/mobx/utils/getEnv";
import { getRoot } from "~/mobx/utils/getRoot";
import type { AxiosResponse } from "axios";
import type { Instance, SnapshotIn, SnapshotOut } from "mobx-state-tree";

export interface PetInstance extends Instance<typeof Pet> {}
export interface PetSnapshotIn extends SnapshotIn<typeof Pet> {}
export interface PetSnapshotOut extends SnapshotOut<typeof Pet> {}

type PetInfo = {
  breedId: string;
  genderId: string;
  insuranceCompanyId: string;
  insuranceNumber: string;
};

export const Pet = types
  .model("User", {
    id: types.identifier,
    name: types.string,
    clientId: types.maybeNull(types.string),
    species: types.maybeNull(Species),
    breed: types.maybeNull(
      types.model("Breed", {
        id: types.string,
        name: types.string,
      }),
    ),
    gender: types.maybeNull(
      types.model("Gender", {
        id: types.string,
        name: types.string,
      }),
    ),
    picture: types.maybeNull(types.string),
    dateOfBirth: types.maybeNull(types.string),
    microchip: types.maybeNull(types.string),
    insuranceCompany: types.maybeNull(
      types.model("InsuranceCompany", {
        id: types.string,
        name: types.string,
      }),
    ),
    insuranceNumber: types.maybeNull(types.string),
    // weight: types.maybe(types.string),

    // missing fields
    castrated: types.maybeNull(types.boolean),
  })
  .actions((self) => {
    return {
      updatePet: flow<PetInstance[], [Partial<PetInfo>]>(
        function* updatePet(data): any {
          const env = getEnv(self);
          const root = getRoot(self);

          const petInfo: Partial<PetInfo> = {
            breedId: self.breed?.id ?? undefined,
            insuranceCompanyId: self.insuranceCompany?.id ?? "",
            insuranceNumber: self.insuranceNumber ?? undefined,
            genderId: self.gender?.id ?? undefined,
            ...data, // override the default values
          };

          const response: AxiosResponse = yield env.baseAuthHttp.put(
            `patients/${self.id}`,
            petInfo,
          );

          const pets = response.data.data;

          response.data = root.petsStore.processOne(pets);

          return response.data;
        },
      ),
    };
  });
